import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { API, AssetCategoryFullDTO } from '../../../../services/api/api';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { MsOptions } from '../../../../services/global/global-interfaces';
import { UtilService } from '../../../../services/util.service';
import { ErrorService } from '../../../../services/error.service';

@Component({
  selector: 'sb-page-asset-category-edit',
  templateUrl: './asset-category-edit.component.html',
  styleUrls: ['./asset-category-edit.component.scss'],
  standalone: false,
})
export class AssetCategoryEditComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  msCategoryOptions: MsOptions;
  @Input() assetCategory: AssetCategoryFullDTO;
  @Input() repositoryId: number;
  @Output() saveClick: EventEmitter<boolean>;
  @Output() deleteClick: EventEmitter<boolean>;
  assetCategories: AssetCategoryFullDTO[];

  constructor(
    public api: API,
    public modalNavigationService: ModalNavigationService,
    public util: UtilService,
    public errorHandler: ErrorService
  ) {
    this.assetCategories = [];
    this.saveClick = new EventEmitter();
    this.deleteClick = new EventEmitter();
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.assetCategory = this.modalNavigationService.getCurrentNavigation().data.assetCategory;
      this.repositoryId = this.modalNavigationService.getCurrentNavigation().data.repositoryId;
    }
  }

  msRequest(type: string, options?: MsOptions) {
    switch (type) {
      case 'ASSET_CATEGORIES':
        if (options) {
          this.msCategoryOptions = options;
        }
        if (this.msCategoryOptions && this.msCategoryOptions.pagination) {
          this.api
            .dm_assets_AssetRepository_getRepoCategories(
              this.repositoryId,
              {
                search: this.util.encodeSearchQueryParam(false, this.msCategoryOptions?.search),
              } /*,
              this.msCategoryOptions?.pagination
              */
            )
            .subscribe(
              (categories: AssetCategoryFullDTO[]) => {
                this.assetCategories = categories;
              },
              error => {
                this.errorHandler.errorHandler(error);
              }
            );
        }
        break;
    }
  }

  update($event: any[], type: string) {
    switch (type) {
      case 'ASSET_CATEGORIES':
        if ($event && $event.length > 0) {
          this.assetCategory.parent = $event[0];
        } else {
          this.assetCategory.parent = null;
        }
        break;
    }
  }
}
